import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'avmTimeSpent',
    standalone: true,
})
export class AvmTimeSpentPipe implements PipeTransform {
    /**
     * Indique la durée écoulée entre le moment présent et la date spécifiée.
     * @param value : Date de reference.
     */
    transform(value: Date): string {
        if (value) {
            let time = Date.now().valueOf() - value.valueOf();

            if (time < 1000 * 60) {
                return "Il y a moins d'une minute";
            } else if (time < 1000 * 60 * 60) {
                let minute = Math.floor(time / (1000 * 60));
                return `Il y a ${minute} minute(s)`;
            } else if (time < 1000 * 60 * 60 * 24) {
                let hour = Math.floor(time / (1000 * 60 * 60));
                return `Il y a ${hour} heure(s)`;
            } else {
                let day = Math.floor(time / (1000 * 60 * 60 * 24));
                return `Il y a ${day} jour(s)`;
            }
        } else {
            return '-';
        }
    }
}
